import { CommonModule } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { SidebarService } from '../../../services/sidebar/sidebar.service';
import { SidebarButtonComponent } from '../sidebar-button/sidebar-button/sidebar-button.component';
import { SidebarButton } from '../model/sidebar-button.type';
import { SIDEBAR_BUTTONS } from '../constant/sidebar-buttons.constant';
import { AuthApiService } from '../../../services/auth/auth-api.service';
import { ThemeToggleComponent } from '../../theme-toggle/theme-toggle.component';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, SidebarButtonComponent, ThemeToggleComponent],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  #sidebarService = inject(SidebarService);
  #authService = inject(AuthApiService);
  buttons: SidebarButton[][] = SIDEBAR_BUTTONS;

  isUserLoggedIn = computed(() => !!this.#authService.user());

  get sidebarDisplay(): boolean {
    return this.#sidebarService.getDisplay();
  }

  get filteredButtons(): SidebarButton[][] {
    return this.buttons.map(buttonList =>
      buttonList.filter(button => {
        return this.shouldShowButton(button);
      })
    );
  }

  shouldShowButton(button: SidebarButton): boolean {
    if (button.label === 'Se déconnecter') {
      return this.isUserLoggedIn();
    }
    return true;
  }
}
